export default __webpack_public_path__ + "static/media/distal-okklusal.d77a7c5d.png";